import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const iconMap = {
  success: <span style={{color: 'green', fontSize: 22, marginRight: 12}}>✔️</span>,
  error: <span style={{color: 'red', fontSize: 22, marginRight: 12}}>❗</span>,
  warning: <span style={{color: 'orange', fontSize: 22, marginRight: 12}}>⚠️</span>,
};

function getToastContent(message, type) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', minWidth: 320, paddingRight: 16 }}>
      {iconMap[type]}
      <div style={{ flex: 1, textAlign: 'center', fontWeight: 500 }}>{message}</div>
      <button
        onClick={() => toast.dismiss()}
        style={{
          background: '#23213D',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          fontWeight: 900,
          cursor: 'pointer',
        }}
        aria-label="close"
      >
        ×
      </button>
    </div>
  );
}

const notificationService = {
  showSuccess: (message) => toast(getToastContent(message, 'success')),
  showError: (message) => toast(getToastContent(message, 'error')),
  showWarning: (message) => toast(getToastContent(message, 'warning')),
};

export default notificationService; 